import { EventEmitter, Injectable, Output } from '@angular/core';
import { NotifierService } from 'angular-notifier';

@Injectable({
  providedIn: 'root'
})
export class AdvancedSearchService {

  appliedSearch: any[] = [{value: ''}];
  public appliedSearchCopy: any[] = [];
  public isAdvancedSearchOpen: boolean = false;
  public commaSearchStr: string = '';
  public selectedTab: string = 'search-by-operator';

  @Output() applySearchEmitter: EventEmitter<any[]> = new EventEmitter<any[]>();

  constructor(
    public notify:NotifierService
  ) { }


  resetSearch(isStopEventEmmiting?: boolean) {
    this.appliedSearch = [{value: ''}];
    this.appliedSearchCopy = [];
    this.commaSearchStr = '';
    if (!isStopEventEmmiting) {
      this.applySearchEmitter.emit([]);
    }
  }

  openSearch(appliedSearch?: any[]) {
    // if (appliedSearch && appliedSearch.length) {
    //   this.appliedSearch = appliedSearch.map(item => ({ ...item }));
    // }
    // else: preserve current state so previously applied values auto-fill on reopen
    this.isAdvancedSearchOpen = true;
  }

  closeSearch() {
    this.isAdvancedSearchOpen = false;
  }

  removeAppliedSearch(index: number) {
    if (this.appliedSearch.length === 1) {
      this.appliedSearch = [{value: ''}];
    }else {
      this.appliedSearch = this.appliedSearch.filter((_, i) => i !== index);
    }
    delete this.appliedSearch[0].operator;
  }

  /**
   * Validates every applied search row.
   * - First row: `value` is required.
   * - Subsequent rows: both `operator` and `value` are required.
   * Marks invalid rows with `invalidValue` / `invalidOperator` flags and
   * returns an object describing the result.
   */
  validateAppliedSearch(): { valid: boolean; message: string } {
    let valid = true;
    let message = '';

    this.appliedSearch.forEach((item, i) => {
      const valueMissing = !item.value || String(item.value).trim() === '';
      const operatorRequired = i > 0;
      const operatorMissing = operatorRequired &&
        (!item.operator || String(item.operator).trim() === '');

      item.invalidValue = valueMissing;
      item.invalidOperator = operatorMissing;

      if (valueMissing || operatorMissing) {
        valid = false;
      }
    });

    if (!valid) {
      message = 'Fill all fields before searching.';
    }
    return { valid, message };
  }

  clearInvalid(index: number) {
    if (this.appliedSearch[index]) {
      this.appliedSearch[index].invalidValue = false;
      this.appliedSearch[index].invalidOperator = false;
    }
  }

  onSearchSubmit(appliedSearch) {
    const payload = appliedSearch
      .filter(item => item && item.value && String(item.value).trim() !== '')
      .map(item => ({
        value: item.value,
        ...(item.operator ? { operator: item.operator } : {})
      }));
    this.appliedSearchCopy = JSON.parse(JSON.stringify(payload));
    this.applySearchEmitter.emit(payload);
    // this.closeSearch();
  }

  // onStrSearchSubmit(appliedSearch: any[]) {
  //   const payload = appliedSearch
  //     .filter(item => item && item.value && String(item.value).trim() !== '')
  //     .map(item => ({
  //       value: item.value,
  //       ...(item.operator ? { operator: item.operator } : {})
  //     }));
  //   this.appliedSearchCopy = JSON.parse(JSON.stringify(payload));
  //   this.applySearchEmitter.emit(payload);
  //   this.closeSearch();

  // }
}
